import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { copyQuestion } from 'utils/urls';

import { Forms } from 'types/forms';
import { ErrorModal } from 'types/modalTypes';

export async function postCopyQuestion({
  accountId,
  formId,
  sectionId,
  questionId,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    copyQuestion(accountId, formId, sectionId, questionId),
    {
      method: 'POST',
      headers: {
        Authorization: getTokenWithType(),
        'content-type': 'application/json',
      },
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Forms;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  formId: number;
  accountId: number;
  sectionId: number;
  questionId: number;
};

type TSnapshot = unknown;

function useCopyQuestion(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { accountId, formId } = params;
    const newFormsInfo = await postCopyQuestion(params);
    if (newFormsInfo.Data && newFormsInfo.StatusCode === 200) {
      queryClient.invalidateQueries(['get_form_details', accountId, formId]);
    } else if (newFormsInfo.Errors) throw newFormsInfo;
    return newFormsInfo;
  });
}

export { useCopyQuestion };
